import { IPricesFiltersState } from '../../../types/developerValuation/pricesFiltersState';
import { TBuildingClass, TPeriod, TRoomCount } from '../../../types/developerValuation/developerValuationFilters';

export interface ISetPriceFilterPayload {
  filterName: keyof IPricesFiltersState;
  filterValue: TBuildingClass[] | TPeriod | TRoomCount[] | number;
}

export const preparePricesFilters = (payload: ISetPriceFilterPayload) => {
  return {
    buildingClass: () => [payload.filterValue],
    period: () => payload.filterValue,
    roomCount: () => [payload.filterValue],
    regionId: () => payload.filterValue,
  };
};
